var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16667 2.25C3.55608 2.25 2.25 3.55608 2.25 5.16667V9.83333C2.25 11.4439 3.55608 12.75 5.16667 12.75H9.83333C11.4439 12.75 12.75 11.4439 12.75 9.83333V5.16667C12.75 3.55608 11.4439 2.25 9.83333 2.25H5.16667ZM11 3.41667C11.322 3.41667 11.5833 3.678 11.5833 4C11.5833 4.322 11.322 4.58333 11 4.58333C10.678 4.58333 10.4167 4.322 10.4167 4C10.4167 3.678 10.678 3.41667 11 3.41667ZM7.5 4.58333C9.11058 4.58333 10.4167 5.88942 10.4167 7.5C10.4167 9.11058 9.11058 10.4167 7.5 10.4167C5.88942 10.4167 4.58333 9.11058 4.58333 7.5C4.58333 5.88942 5.88942 4.58333 7.5 4.58333ZM7.5 5.75C7.03587 5.75 6.59075 5.93437 6.26256 6.26256C5.93437 6.59075 5.75 7.03587 5.75 7.5C5.75 7.96413 5.93437 8.40925 6.26256 8.73744C6.59075 9.06563 7.03587 9.25 7.5 9.25C7.96413 9.25 8.40925 9.06563 8.73744 8.73744C9.06563 8.40925 9.25 7.96413 9.25 7.5C9.25 7.03587 9.06563 6.59075 8.73744 6.26256C8.40925 5.93437 7.96413 5.75 7.5 5.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4b0d128a748f0826be5a1fc96c8c24bf.svg";
export { ForwardRef as ReactComponent };